import { calcDateTime, startOfDateTime, endOfDateTime } from '@occc-app/lib/date';

export const NUMERIC_ABBREVIATIONS = [
  { abbreviation: 'B', minValue: 1000000000 },
  { abbreviation: 'M', minValue: 1000000 },
  { abbreviation: 'K', minValue: 1000 },
];

export const DEFAULT_METRIC_START_DATE = startOfDateTime(
  calcDateTime(new Date(), 'sub', 1, 'week'),
  'day',
);
export const DEFAULT_METRIC_END_DATE = endOfDateTime(
  calcDateTime(new Date(), 'sub', 1, 'day'),
  'day',
);
export const DEFAULT_INTERVAL = 'day';
export const DEFAULT_METRIC_TYPE = 'members';
export const DEFAULT_PLOT_CUMULATIVE = false;

export const DATA_KEYS = {
  REFERENCE_RANGE: 'REFERENCE_RANGE',
  CURRENT_RANGE: 'CURRENT_RANGE',
};
